import React from "react";

function AiTimelineAndOdds({
  aiDate,
  ailitigation,
  aiEvidence = [],
}) {
  return (
    <div className="font-plexsans">
      <h2 className="text-2xl font-spectral text-navy mb-4">
        Timeline & Evidence
      </h2>

      <div className="grid grid-cols-2 gap-3 mb-3">

        <div className="border border-[rgba(20,33,61,.12)] rounded-[10px] p-4">
          <div className="text-[13px] text-[rgba(20,33,61,.5)]">
            Filing deadline
          </div>
          <div className="text-xl font-semibold text-navy mt-1">
            {aiDate}
          </div>
        </div>

        <div className="border border-[rgba(20,33,61,.12)] rounded-[10px] p-4">
          <div className="text-[13px] text-[rgba(20,33,61,.5)]">
            Litigation time
          </div>
          <div className="text-xl font-semibold text-navy mt-1">
            {ailitigation} months
          </div>
        </div>

      </div>

      {/* Evidence */}
      <div>
        <div className="text-[13px] font-medium text-tan mb-2.5">
          Key evidences to collect
        </div>

        <ul className="space-y-2">
          {/* The AI is now told not to pad this list (see
              caseValuationPrompt.js), but filtering blanks here too means a
              stray empty item never shows as a checkmark with nothing next
              to it. */}
          {aiEvidence.filter((item) => item?.trim()).map((item, index) => (
            <li
              key={index}
              className="flex items-start gap-2 text-[14px] text-navy"
            >
              <span className="text-tan mt-0.5">
                ✓
              </span>

              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
}

export default AiTimelineAndOdds;
